import { Grid, styled, Box, Button } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  marginTop: '64px',
});

const TopHeadingGrid = styled(Grid)({
  margin: '20px 20px 7px 20px',
  display: 'flex',
  justifyContent: 'space-between',
});

const SubmitButton = styled(Button)({
  color: ColorsV2.acent,
  '&:hover': {
    color: ColorsV2.white,
    backgroundColor: ColorsV2.acent,
  },
  '&:disabled': {
    color: '#808080',
    backgroundColor: ColorsV2.primary,
  },
});

export { Container, TopHeadingGrid, SubmitButton };
